import { FC } from 'react';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';

type Props = {
  width: number;
}

const QuestionScoringBar:FC<Props> = ({ width }) => {
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady || !quiz.questionsSettings.timeout ) return null;
  return (
    <div
      className="relative w-full bg-gray-200 border-4 border-gray-200 h-6 rounded-lg mb-4"
    >
      <div className="absolute top-0 left-0 w-full h-4 opacity-25 rounded z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
      <div className="absolute top-0 left-0 h-4 rounded z-10" style={{ width: `${width}%`, backgroundColor: quiz.theme.progressBarColor }}></div>
    </div>
  )
}

export default QuestionScoringBar;
